import React ,{useRef,useState}from 'react'
import "../Login/Login.css"
import { motion, AnimatePresence, delay } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import logo from '../Images/logo.png'
import FormComponent from '../components/FormComponents/FormComponent';
import OtpInput from 'react-otp-input';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import axios from 'axios';
import loading from "../Images/three-dots.svg"
import { useFormik } from 'formik';
import * as Yup from "yup";
import BackEndUrl from '../backURL';
import NumberCaptcha from './NumberCaptcha';


const backend = BackEndUrl.domain
const ContactUs = () => {

    const [isCaptchaValid, setCaptchaValid] = useState(false);
    const [resetCaptcha, setResetCaptcha] = useState(false);

    const toast = useRef(null);
    const formik = useFormik({
        initialValues:{
            mobile:"",
            message:""
        }
        ,validationSchema:Yup.object({
            mobile: Yup.string()
                .required("Mobile is required").max(10,"Invalid Number").min(10,"Invalid Number"),
           message: Yup.string().required("*Required")
           
           
        }),
    })
  
    async function TokenCreation() {
        try {

            const response = await axios.post(backend + "/auth-token", {
                nic: formik.values.mobile,
                mobile: formik.values.mobile,
            }
            )

            sessionStorage.setItem("token", response.data.token)
            // sessionStorage.setItem('nic', '000000000V')
            // sessionStorage.setItem('mobile', formik.values.mobile)
            // sessionStorage.setItem('message', formik.values.message)
            // sessionStorage.setItem('logged', false)
            //window.location.href = '/customer-portal/'
        }
        catch (err) {
            console.log(err);
        }
    }

   async  function onClickSend(){

    //contactUsRequestCountLoad(formik.values.mobile);   
    if (isCaptchaValid) {
        
        setResetCaptcha(false);
        formik.validateForm().then(async (errors) => {

                        TokenCreation();
            
            
                        if (Object.keys(errors).length === 0) {
                            
                        const response = await axios.post(backend+"/contact_us_req",{
                            mobile:formik.values.mobile,
                            message:formik.values.message
                        }, {
                            headers: {
                                Authorization: sessionStorage.getItem('token'),
                            }
                        })

                        console.log(response.data);
                        
                        if(response.data=="Data added successfully"){
                            //contactUsRequestCountLoad(formik.values.mobile);
                            setResetCaptcha(true);
                            formik.resetForm();
                            toast.current.clear();
                            toast.current.show({
                            severity: 'success',
                            summary: 'Request Sent Sucessfully',
                            description: "Request Sent Sucessfully",
                            life: 5000,
                            sticky: false,
                            content: (props) => (
                                <div className="p-3" style={{ flex: '1' }}>
                                <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                                <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                                </div>
                            ),
                            });
                            
                        }
                        else if(response.data=="You have a pending request"){
                                setResetCaptcha(true);
                                formik.resetForm();
                                toast.current.clear();
                                toast.current.show({
                                severity: 'error',
                                summary: 'Pending Requests',
                                description: "You have already applied for a request recently. Please wait for the confirmation..",
                                life: 7000,
                                sticky: false,
                                content: (props) => (
                                    <div className="p-3" style={{ flex: '1' }}>
                                    <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                                    <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                                    </div>
                                ),
                                });
                        }
                        else if(response.data=="Cooldown period not yet over"){
                            
                            toast.current.clear();
                            toast.current.show({
                            severity: 'error',
                            summary: 'Too many messages',
                            description: "Try again Later",
                            life: 3000,
                            sticky: false,
                            content: (props) => (
                                <div className="p-3" style={{ flex: '1' }}>
                                <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                                <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                                </div>
                            ),
                            });
                        }

                        }
                        else{
                            toast.current.clear();
                            toast.current.show({
                            severity: 'error',
                            summary: 'Invalid or mising information',
                            description: "please check the given information",
                            life: 3000,
                            sticky: false,
                            content: (props) => (
                                <div className="p-3" style={{ flex: '1' }}>
                                <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                                <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                                </div>
                            ),
                            });
                        }    
            
        
        
        })

    }else {
        //setResetCaptcha(false);
        toast.current.clear();
                toast.current.show({
                  severity: 'error',
                  summary: 'Please solve the question correctly',
                  description: "Please solve the given CAPTCHA correctly",
                  life: 3000,
                  sticky: false,
                  content: (props) => (
                    <div className="p-3" style={{ flex: '1' }}>
                      <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                      <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                    </div>
                  ),
                });
      }


    
    
    

     }
  return (
    <div > 
         <Toast ref={toast} position="top-center"/>
     <Row className='d-flex justify-content-center  align-items-center' style={{height:"100dvh"}}>
        <Col lg={6} md={9} sm={11} xs={11}>
            
        <motion.div
                                initial={{
                                    borderTopLeftRadius: "0em",
                                    borderTopRightRadius: "40em",
                                    borderBottomLeftRadius: "40em",
                                    borderBottomRightRadius: "0em",
                                    scale: 0.5,
                                    opacity: 0,



                                }}
                                animate={{
                                    opacity: 1,
                                    borderTopLeftRadius: "0em",
                                    borderTopRightRadius: "9em",
                                    borderBottomLeftRadius: "9em",
                                    borderBottomRightRadius: "0em",
                                    scale: 1

                                }}



                                className='login-inner' style={{height:"80vh"}}>
                                <motion.div
                                    initial={{

                                        opacity: 0

                                    }}
                                    animate={{
                                        opacity: 1

                                    }}
                                    exit={{
                                        opacity: 0

                                    }}
                                    transition={{ duration: 0.3 }}

                                >
                                    <Row>
                                        <Col xs={2} className='logo-con mx-3 mt-2'>
                                            <img src={logo}  style={{width:"69%"}} className='logo' />
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col xs={12} className='d-flex justify-content-center'>
                                            <h2 className='title'><span style={{ color: "#00aaef",fontSize:"4vh" }}>Contact </span> <span style={{ color: "#f7941d",fontSize:"4vh" }}>Us</span> </h2>
                                        </Col>
                                    </Row>
                                    <Row  className='d-flex justify-content-center'>
                                    <Col lg={6} md={7} sm={8} xs={8} className='my-4'>
                                    <FormComponent
                                                    type="input-number"
                                                    label="Mobile Number"   
                                                    name={"mobile"}                                                
                                                    value={formik.values.mobile}
                                                    onChange={formik.handleChange}                                                    
                                                    errors={formik.errors.mobile}
                                                    
                                                    style={
                                                        { height: "9vh" }
                                                    }

                                                />
                                    <FormComponent
                                                    type="text-area"
                                                    label="Message (Please mention your NIC number and Policy number)"   
                                                    name={"message"}                                                
                                                    value={formik.values.message}
                                                    onChange={formik.handleChange}                                                    
                                                    errors={formik.errors.message}  
                                                />

                                    <NumberCaptcha onCaptchaChange={setCaptchaValid}  reset={resetCaptcha} style={{marginTop:"10px"}}/>

                                    </Col>
                                    <Row className='d-flex justify-content-end '>
                                        <Col lg={7} md={7} sm={12} className='d-flex flex-row justify-content-start'>
                                            <p className='me-5 ms-5 ms-lg-0 '><a href='https://www.appsheet.com/start/e515ebca-b9a8-4fe8-808d-c8d28446adb0 ' target='_blank' className='underline-link'>Feedback </a></p>


                                        </Col>

                                        <Col xs={3} className='justify-content-start d-flex'>

                                            <motion.button
                                                whileTap={{ scale: 0.9 }}
                                                className={`btn btn-warning login-btn  `}
                                               
                                                onClick={() => { onClickSend()}}
                                                style={{ height: "120%" }}
                                            >
                                                <span className='d-flex flex-column' style={{ position: "relative" }}>
                                                    <span> Send</span>
                                                    

                                                </span>
                                            </motion.button>
                                            
                                        </Col>
                                    </Row>
                                    </Row>
                                    


                                </motion.div>


        </motion.div>
        </Col>
     </Row>
    </div>
  )
}

export default ContactUs
